var _circle, _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChallengeMindset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#E69310"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0005 29.9996C23.2848 29.9996 30.0005 23.2839 30.0005 14.9996C30.0005 12.4172 29.3479 9.98726 28.1987 7.86562C25.5617 5.56164 22.1108 4.16577 18.334 4.16577C10.0497 4.16577 3.33398 10.8815 3.33398 19.1658C3.33398 21.7481 3.98655 24.1781 5.13578 26.2998C7.77283 28.6037 11.2237 29.9996 15.0005 29.9996Z",
    fill: "#F9A623"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_910_20799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4375 15.0001L24.8947 13.0571C25.0146 12.8973 25.0339 12.6836 24.9445 12.5049C24.8552 12.3262 24.6726 12.2134 24.4728 12.2134H21.6486C21.4827 12.2134 21.3264 12.2915 21.2268 12.4243L19.5322 14.6837C19.3916 14.8712 19.3916 15.129 19.5322 15.3165L21.2268 17.5759C21.3264 17.7087 21.4827 17.7868 21.6486 17.7868H24.4728C24.6726 17.7868 24.8552 17.674 24.9445 17.4953C25.0339 17.3167 25.0146 17.1029 24.8947 16.9431L23.4375 15.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0419 14.4726H18.2624C18.0035 12.5201 16.328 11.0085 14.3058 11.0085C12.105 11.0085 10.3145 12.7991 10.3145 14.9999C10.3145 17.2008 12.105 18.9913 14.3058 18.9913C16.328 18.9913 18.0035 17.4798 18.2624 15.5273H17.0419C16.7946 16.8125 15.6621 17.7867 14.3058 17.7867C12.7692 17.7867 11.5191 16.5365 11.5191 14.9999C11.5191 13.4633 12.7692 12.2132 14.3058 12.2132C15.6621 12.2132 16.7946 13.1874 17.0419 14.4726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3829 18.2087L19.117 16.5208C18.4703 18.5623 16.5581 20.0461 14.3055 20.0461C11.523 20.0461 9.25939 17.7825 9.25939 15C9.25939 12.2176 11.523 9.95397 14.3055 9.95397C16.5581 9.95397 18.4703 11.4378 19.117 13.4793L20.3828 11.7915C20.4746 11.6692 20.5831 11.5622 20.7039 11.4726C19.4595 9.22022 17.0608 7.69458 14.3055 7.69458C10.2708 7.69458 7 10.9653 7 15C7 19.0348 10.2708 22.3055 14.3055 22.3055C17.0608 22.3055 19.4595 20.7799 20.7039 18.5276C20.5831 18.4379 20.4746 18.331 20.3829 18.2087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3053 14.4728H15.955C15.7313 13.7748 15.0765 13.2681 14.3053 13.2681C13.3502 13.2681 12.5732 14.0451 12.5732 15.0001C12.5732 15.9552 13.3502 16.7322 14.3053 16.7322C15.0765 16.7322 15.7313 16.2254 15.955 15.5275H14.3053C14.0141 15.5275 13.7779 15.2913 13.7779 15.0001C13.7779 14.7089 14.0141 14.4728 14.3053 14.4728Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_910_20799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(7 6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallengeMindset);
export default __webpack_public_path__ + "static/media/challenge-mindset.a07673d8b3f21ab5ba434d6778f440fd.svg";
export { ForwardRef as ReactComponent };